import {authHeader} from '../_helpers';
import {handleResponse} from '../_helpers';


export const locationService = {
    getLocationCollection,
    getLocationItem
};


async function getLocationCollection() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let  allLocations= [];
    let currentPage = 1;
    let totalPages;

    do {
        const response = await fetch(`${process.env.VUE_APP_API_SERVER}/api/locations?page=${currentPage}`, requestOptions);
        const data = await handleResponse(response);

        if (currentPage === 1) {
            allLocations = data
        } else {
            allLocations['hydra:member'] = allLocations['hydra:member'].concat(data['hydra:member']);
        }

        totalPages = Math.ceil(data['hydra:totalItems'] / 30);
        currentPage++;
    } while (currentPage <= totalPages);

    return allLocations;
}


function getLocationItem(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.VUE_APP_API_SERVER+`/api/locations/`+id, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}